import React from "react";
import { Resource } from "react-admin";
import UtilititesIcon from "@material-ui/icons/Build";

import List from "./List";

export default <Resource name="utilities" icon={UtilititesIcon} list={List} />;



// WEBPACK FOOTER //
// ./src/resources/Utilities/index.js